export default __webpack_public_path__ + "static/media/IMG_2558.f36a2317.PNG";